import React, { useEffect } from "react";
import "../CSS/styles.css";
import contact from "../../assets/contact.png";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Slider9 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);
  return (
    <div className="container-fluid mt-lg-5 mt-4 px-0" data-aos="fade-down">
      <div className="row pt-4 justify-content-center">
        <div className="col-12">
          <div className="image-gradient-wrap3">
            <img src={contact} alt="2" className="img-fluid" />
            <div className="gradient-over3"></div>
            <div className="over-cont3 d-flex flex-column align-items-center justify-content-center">
              <h1 className="fw-bolder mt-lg-3 inter h0 mb-0 text-center">New Cyber Security Threats in <br /> 2023</h1>
              <div className="d-flex align-items-center mt-lg-3">
                <div className="d-flex align-items-center">
                  <div>
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_65_15605)">
                        <path d="M5.58594 1.3252V3.99186" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.918 1.3252V3.99186" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12.917 2.6582H3.58594C2.84974 2.6582 2.25293 3.25501 2.25293 3.99121V13.3223C2.25293 14.0585 2.84974 14.6553 3.58594 14.6553H12.917C13.6532 14.6553 14.25 14.0585 14.25 13.3223V3.99121C14.25 3.25501 13.6532 2.6582 12.917 2.6582Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2.25293 6.65723H14.25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_65_15605">
                          <rect width="15.9961" height="15.9961" fill="white" transform="translate(0.253906 -0.0078125)" />
                        </clipPath>
                      </defs>
                    </svg>

                  </div>
                  <div>
                    <p className="wrc mb-0 ms-2">June 15, 2023</p>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div>
                    <p className="wrc mb-0 ms-3">•</p>
                  </div>
                  <div>
                    <p className="wrc mb-0 ms-3">Cyber Security</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Slider9
